module.exports = __webpack_public_path__ + "static/media/en.66ef0749.png";